import * as React from "react";
const SvgLschen = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Löschen">
    <path
      fill="currentColor"
      d="M161.64 37.95v-9.63c0-3.67-2.98-6.65-6.65-6.65h-53.98c-3.67 0-6.65 2.98-6.65 6.65v9.63H54.69c-3.67 0-6.65 2.98-6.65 6.65v31.74c0 3.67 2.98 6.65 6.65 6.65h6.65v131.57c0 10.92 8.85 19.77 19.77 19.77h93.79c10.92 0 19.77-8.85 19.77-19.77V82.99h6.65c3.67 0 6.65-2.98 6.65-6.65V44.6c0-3.67-2.98-6.65-6.65-6.65h-39.67Zm12.82 181.38H81.54c-2.87 0-5.2-2.33-5.2-5.2V82.99h103.32v131.14c0 2.87-2.33 5.2-5.2 5.2m18.5-151.34H63.04V52.95h129.92z"
    />
    <rect x={96.89} y={100.25} fill="currentColor" rx={6.65} ry={6.65} />
    <rect x={142.75} y={100.25} fill="currentColor" rx={6.65} ry={6.65} />
  </svg>
);
export default SvgLschen;
